import { AsyncPipe, DecimalPipe } from "@angular/common";
import {
    Component,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { RowComponent } from "@components/row/row.component";
import { TogglePanelComponent } from "@components/toggle-panel/toggle-panel.component";
import { Observable, Subject } from "rxjs";
import { map, shareReplay, takeUntil } from "rxjs/operators";
import { Kontrakt } from "~app/features/virkeskop/models/kontrakt-models";
import { ApiClientService } from "../../../../common/services/api-client.service";
import { Vardeberakning } from "../../models/vardeberakning/vardeberakning-models";
import { KontraktMediatorService } from "../../services/kontrakt-mediator.service";

@Component({
    selector: "rask-vardeberakning",
    templateUrl: "./vardeberakning.component.html",
    styleUrls: ["./vardeberakning.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TogglePanelComponent,
        RowComponent,
        AsyncPipe,
        DecimalPipe
    ]
})
export class VardeberakningComponent implements OnInit, OnDestroy {
    protected kontraktId$: Observable<number>;
    protected vardeberakning$: Observable<Vardeberakning[]>;
    protected kontrakt: Kontrakt = new Kontrakt();

    private readonly destroy$ = new Subject<void>();
    private readonly apiClient = inject(ApiClientService);
    private readonly kontraktMediatorService = inject(KontraktMediatorService);

    ngOnInit(): void {
        this.kontraktMediatorService.kontrakt$.pipe(
            takeUntil(this.destroy$)
        ).subscribe(kontrakt => {
            this.kontrakt = kontrakt;
        });

        this.kontraktId$ = this.kontraktMediatorService.kontrakt$.pipe(
            map(kontrakt => kontrakt.id),
            shareReplay(1));

        this.vardeberakning$ = this.kontraktMediatorService.vardeberakning$;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    downloadDokument(kontraktId:  number) {
        this.getVardeberakningStreamForKontrakt(kontraktId, false).subscribe((blob: Blob) => {
            if (blob) {
                const filename = `${this.kontrakt.kontraktnummer}_Värdeberäkning_${this.kontrakt.benamning}.pdf`;
                const downloadLink = document.createElement("a");
                downloadLink.href = window.URL.createObjectURL(blob);
                downloadLink.download = filename;
                downloadLink.click();
            }
        });
        return false;
    }

    openDokument(kontraktId:  number) {
        this.getVardeberakningStreamForKontrakt(kontraktId, true).subscribe((blob: Blob) => {
            const url = URL.createObjectURL(blob);
            window.open(url);
        });
        return false;
    }

    getVardeberakningStreamForKontrakt(kontraktId:  number, view: boolean): Observable<any> {
        const fileUrl = `virkeskopskontrakt/${kontraktId}/utskrift/vardeberakning/${view ? "visa" : "nedladdning"}`;
        return this.apiClient.getRaw(fileUrl, false,  { responseType: "blob" });
    }
}
